import http from '@/http';

export default {
    list() {
        return http.get('/demand-types');
    },
    get(id) {
        return http.get(`/demand-types/${id}`);
    },
    remove(id) {
        return http.delete(`/demand-types/${id}`);
    },
    save(form) {
        return http.post('/demand-types', form);
    },
    update(id, form) {
        return http.put(`/demand-types/${id}`, form);
    },
};



// WEBPACK FOOTER //
// ./src/api/demandTypes.js